import { render, staticRenderFns } from "./LiveBlogSummaryBlock.vue?vue&type=template&id=5f5a2e4b&"
import script from "./LiveBlogSummaryBlock.vue?vue&type=script&lang=js&"
export * from "./LiveBlogSummaryBlock.vue?vue&type=script&lang=js&"
import style0 from "./LiveBlogSummaryBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports